import { render } from "./ApprovalCard.vue?vue&type=template&id=3c3fdc13&scoped=true"
import script from "./ApprovalCard.vue?vue&type=script&lang=js"
export * from "./ApprovalCard.vue?vue&type=script&lang=js"

import "./ApprovalCard.vue?vue&type=style&index=0&id=3c3fdc13&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3fdc13"]])

export default __exports__